<template>
  <div>
    <div v-if="comenzo == false">
      <section id="dinamica">
        <div class="bannerprincipal row d-lg-none">
          <div class="col-4 pt-3">
            <img
              src="../assets/imgs/verano23/logo-verano-cinepolis.png"
              alt="Verano Cinépolis"
              class="img-fluid"
            />
          </div>
        </div>

        <div class="row pt-lg-5">
          <div class="col-lg-6 d-none d-lg-block">
            <img
              src="../assets/imgs/verano23/mnms-verano.png"
              alt="Verano Cinépolis"
              class="img-fluid"
            />
          </div>

          <div class="col-12 col-lg-6 text-center pt-0 pt-lg-5 px-5">
            <div class="row">
              <div class="col-12 text-center fanta amarillo fXXG2 pb-4 pt-lg-5">
                ¡Hola {{ userProfile.nombre }}!
              </div>
            </div>

            <div class="row">
              <div class="col-12 text-center fanta fXG2">
                <span class="amarillo"
                  >Elige la respuesta correcta para cada película</span
                >
                <span class="blanco">
                  en menos de 30 segundos y prepárate para ganar.</span
                >
              </div>
            </div>

            <button
              @click="initJuego()"
              class="my-5 amarillo pointer d-flex align-items-center justify-content-center btnaction2 fXG2 fanta ml-auto mr-auto w-100"
            >
              JUGAR
            </button>

            <div class="row d-block d-lg-none">
              <div class="col-12 text-center fanta fXG2">
                <img
                  class="img-fluid"
                  src="../assets/imgs/verano23/mnms1.png"
                  alt="m&ms"
                />
              </div>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </section>
    </div>
    <div v-else>
      <section id="juego" class="">
        <div class="row botonera">
          <div class="col-4 col-lg-3 pt-3">
            <img
              src="../assets/imgs/verano23/logo-verano-cinepolis.png"
              alt="Verano Cinépolis"
              class="img-fluid"
            />
          </div>
          <div class="col-8 col-lg-9 pt-5">
            <div class="row d-flex d-md-none">
              <div class="col-4"></div>
              <div class="col-8">
                <div class="row">
                  <div class="col-6 blanco fanta fG">
                    {{ userProfile.nombre }}
                  </div>
                  <div class="col-6 blanco fanta fG">
                    {{ time_txt }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="overlayjuego">
          <div class="globo">
            <div class="botoneradesk d-none d-md-flex">
              <div class="row">
                <div class="col-6 blanco fanta fG">
                  {{ userProfile.nombre }}
                </div>
                <div class="col-6 blanco fanta fG">
                  {{ time_txt }}
                </div>
              </div>
            </div>
            <img src="../assets/imgs/verano23/globo.png" alt="globo" />
          </div>

          <div class="frase azuloscuro">
            <img
              class="img-fluid w-100"
              :src="
                require('../assets/imgs/verano23/preguntas/img' +
                  disponibles_temp[indice_pregunta].id +
                  '.jpg')
              "
              alt="pantalla"
            />
          </div>

          <div class="opciones pt-3 z100">
            <div
              class="opcion btnaction4 mb-3 fanta fG z100"
              @click="
                seleccionaOpcion(disponibles_temp[indice_pregunta].opciones[0])
              "
            >
              <div class="">
                <span v-html="disponibles_temp[indice_pregunta].opciones[0]"></span>
              </div>
            </div>

            <div
              class="opcion btnaction4 mb-3 fanta fG z100"
              @click="
                seleccionaOpcion(disponibles_temp[indice_pregunta].opciones[1])
              "
            >
              <div class="">
                <span v-html="disponibles_temp[indice_pregunta].opciones[1]"></span>
              </div>
            </div>

            <div
              class="opcion btnaction4 mb-3 fanta fG z100"
              @click="
                seleccionaOpcion(disponibles_temp[indice_pregunta].opciones[2])
              "
            >
              <div class="">
                <span v-html="disponibles_temp[indice_pregunta].opciones[2]"></span>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-12 py-5 d-none d-md-block"></div>
          <div class="col-12 py-5 d-none d-md-block"></div>
          <div class="col-12 py-5 d-none d-md-block"></div>
          <div class="col-5 offset-7 text-right">
            <img src="../assets/imgs/verano23/mnms1.png" alt="m&m" class="img-fluid">
          </div>
        </div> -->
      </section>

      <span
        class="loading"
        v-bind:class="{ active: this.$store.state.loading }"
      >
        <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
      </span>
    </div>

    <div class="hidden" v-for="pregunta in preguntas" :key="pregunta.id">
      <img
        rel="preload"
        :src="
          require('../assets/imgs/verano23/preguntas/img' +
            pregunta.id +
            '.jpg')
        "
        alt="preloaded"
      />
    </div>
  </div>
</template>

<script>
import { commentsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import Footer from "@/components/Footer";

const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const TIEMPO_PARTICIPACION = 30;
const MAX_MATCHES = 35;
const MAX_NOMATCHES = 45;
const MAX_COCACINEPOLIS = 20;
const MAX_TARJETAS = MAX_MATCHES + MAX_COCACINEPOLIS + MAX_NOMATCHES;

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      isRunning: false,
      time: 0,
      time_init: 0,
      time_txt: TIEMPO_PARTICIPACION,
      ahora: moment(),
      indice: 0,
      respuesta_actual: null,
      puntos: 0,
      respuestas: {
        res: [],
        correctas: 0,
      },
      termino: false,
      comenzo: false,
      standBy: false,
      dulceria: [
        "dulceria1",
        "dulceria2",
        "dulceria3",
        "dulceria4",
        "dulceria5",
        "dulceria6",
        "dulceria7",
        "dulceria8",
        "dulceria9",
        "dulceria10",
        "dulceria11",
      ],
      siluetas: [
        {
          frase: "Copiloto del último maestro Jedi",
          silueta: "r2d2",
          opciones: [],
          eleccion: "",
        },
      ],
      preguntas: [
        {
          id: 1,
          opciones: [
            "Que la fuerza te acompañe",
            "Nadie es perfecto",
            "Oh, capitán, mi capitán",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 2,
          opciones: [
            "¡Sin sombrero no hay vaquero!",
            "Somos quienes elegimos ser",
            "¡Es porque soy verde! <span class='espejo'>¿</span>Verdad?​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 3,
          opciones: [
            "Si Pato come pez ¡sería una abominación!",
            "<span class='espejo'>¿</span>Me estás hablando a mí?",
            "Vivimos en Aloha",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 4,
          opciones: [
            "¡Viscosos, pero sabrosos!",
            "¡Ya están aquííí!",
            "No me acuerdo de olvidarte",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 5,
          opciones: [
            "<span class='espejo'>¿</span>Princesa? <span class='espejo'>¿</span>Pos qué te pasó?",
            "Por favor, búrlate de mí en silencio",
            "Tonto es el que hace tonterías​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 6,
          opciones: [
            "Si tú saltas, yo salto",
            "Francamente, querida, me importa un bledo",
            "Shane. Shane. ¡Vuelve!​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 7,
          opciones: [
            "¡Libre soy!",
            "La Era de Hielo está 'out'",
            "Vivíamos en un mundo encantado",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 8,
          opciones: [
            "¡Volveré!",
            "Un alma no es igual a otra",
            "Nos volvemos a ver​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 9,
          opciones: [
            "Genio, <span class='espejo'>¿</span>qué es lo que tú más deseas?",
            "¡Buenos días princesa!",
            "Una casa encantadora​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 10,
          opciones: [
            "Expecto Patronum",
            "Soy mago. Lo voy a averiguar",
            "Nada es lo que parece​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 11,
          opciones: [
            "Terror en su faz, ratas por detrás",
            "¡No, estoy contigo!",
            "Solo quiero que sea feliz​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 12,
          opciones: [
            "<span class='espejo'>¿</span>El Olimpo está por allí?",
            "Los sueños nos salvan",
            "Un hombre fuerte, es más fuerte solo",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 13,
          opciones: [
            "Mi sentido arácnido está en alerta",
            "No tengo nada que demostrarte",
            "Esto no va a terminar bien​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 14,
          opciones: [
            "Estaba soñando con Ricky",
            "Seremos cobardes, pero cobardes rápidos",
            "Su identidad es su posesión más valiosa ¡Protéjanla!​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 15,
          opciones: ["Bididi Badidid Bum", "Abra Cadabra ", "Hocus Pocus​"],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 16,
          opciones: [
            "La lógica es el arma suprema",
            "Tenemos un Hulk",
            "Chewie... estamos en casa",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 17,
          opciones: [
            "Casi te gano",
            "Si tú saltas, yo salto",
            "¡Mejor fuera que adentro!",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 18,
          opciones: [
            "No puedes sentarte con nosotras",
            "Soy una papa casada",
            "Siempre nos quedará París",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 19,
          opciones: [
            "Te amo 3000",
            "Todo es posible, incluso lo imposible",
            "Soy la persona más ambiciosa",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 20,
          opciones: [
            "Podría estar haciendo esto todo el día",
            "Con cada combate te haces más fuerte",
            "Que la fuerza te acompañe​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 21,
          opciones: ["Mi tesoro", "Mi bebé", "Mi dinero​"],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 22,
          opciones: [
            "Ahora toda China sabe que están aquí",
            "Soy de tobillos frágiles",
            "Vivir… esa será mi mejor aventura​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 23,
          opciones: [
            "¡Sin sombrero no hay vaquero!",
            "Busca lo más vital, no más",
            "Libre soy",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 24,
          opciones: [
            "No me quiero ir Sr. Stark",
            "No me quiero ir Sr. Spiderman",
            "No me quiero ir Sr. Iron Man​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 25,
          opciones: [
            "Yo soy Groot",
            "No somos machos pero somos muchos",
            "Yo tengo el poder",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 26,
          opciones: [
            "¡Wow! Ojalá yo hablara cetáceo",
            "La buena comida es como la música",
            "Todo lo que hay en esta sala es comestible​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 27,
          opciones: [
            "Yo sí creo en las hadas",
            "Las hadas no existen",
            "<span class='espejo'>¿</span>Qué es un hada?​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 28,
          opciones: [
            "<span class='espejo'>¿</span>Estás hablando conmigo?",
            "E. T., teléfono, mi casa",
            "Siempre nos quedará París",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 29,
          opciones: [
            "Le voy a hacer una oferta que no podrá rechazar",
            "Veo gente muerta",
            "Houston, tenemos un problema",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 30,
          opciones: [
            "<span class='espejo'>¿</span>Zeus, el pez gordo, es tu papá?",
            "Si tú saltas, yo salto",
            "Debo dejar de pretender ser algo que no soy​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 31,
          opciones: [
            "Siempre tendremos París",
            "Voy a amarte, no importa qué",
            "Sentí que se me partía el corazón",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 32,
          opciones: [
            "Mi vida es una completa comedia",
            "Es tan bella como loca",
            "Ten cuidado con lo que deseas​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 33,
          opciones: [
            "Respíralo, eso es miedo",
            "Volveré",
            "Hasta la vista, baby",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 34,
          opciones: ["¡Esto es Esparta!", "Esto es Brasil", "¡Libertad!​"],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 35,
          opciones: [
            "¡Teniente Daaaaan!",
            "<span class='espejo'>¿</span>Hablas conmigo?",
            "¡Stella! ¡Hey, Stella!",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 36,
          opciones: [
            "<span class='espejo'>¿</span>Por qué tan serio?",
            "Rendirse es para los novatos",
            "Lo siento llegué tarde​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 37,
          opciones: [
            "El miedo es el camino hacia el Lado Oscuro",
            "Yo soy inevitable",
            "Yo soy Moana​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 38,
          opciones: [
            "<span class='espejo'>¿</span>Los hombres van a salvar al mundo? Yo no creo",
            "P. Sherman calle 42 Sidney",
            "La aventura está allá afuera​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 39,
          opciones: [
            "150, chico, y sigo joven",
            "No soy un guppy",
            "Solo sé olvidar, es lo que hago mejor​​",
          ],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
        {
          id: 40,
          opciones: ["¡Muéstrame el dinero!", "Robamos bancos", "¡Mi tesoro!​"],
          rcorrecta: "",
          seleccionada: "",
          escorrecta: false,
        },
      ],
      disponibles_temp: [],
      dulceria_temp: [],
      matches_final: [],
      matches: [],
      nomatches: [],
      cocacinepolis: [],
      preguntas_listas: false,
      indice_pregunta: 0,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.construyePreguntas();
  },
  methods: {
    seleccionaOpcion(respuesta) {
      //console.log(respuesta)

      if (this.isRunning === true) {
        this.disponibles_temp[this.indice_pregunta].seleccionada = respuesta;

        if (this.indice_pregunta + 1 < this.disponibles_temp.length) {
          this.indice_pregunta++;
        } else {
          //todo: anadir que no se pueda dar más de un click
          this.terminarJuego();
        }
      }
    },
    construyePreguntas() {
      this.resetDisponibles();

      //console.log({preguntas: this.disponibles_temp})

      this.preguntas_listas = true;
    },
    resetDisponibles() {
      // this.disponibles_temp = [...this.siluetas];
      // this.disponibles_temp = this.shuffle(this.disponibles_temp);
      //console.log({ reset: this.disponibles_temp });

      let thes = this;
      this.disponibles_temp = [...this.preguntas];
      this.disponibles_temp = this.shuffle(this.disponibles_temp);

      this.disponibles_temp.forEach((element) => {
        element.rcorrecta = element.opciones[0];
        element.opciones = thes.shuffle(element.opciones);
      });

      console.log({ resetDisponibles: this.disponibles_temp });
    },

    releaseStandBy() {
      this.standBy = false;
    },
    animarCorazon() {
      // let corazon = this.$refs.corazon;
      // let svg = document.createElement("span");
      // svg.innerHTML = `<svg
      //                 ref=""
      //                 width="40"
      //                 class="ml-2 mt-n2 animado"
      //                 enable-background="new 0 0 24 24"
      //                 id="Layer_1"
      //                 version="1.0"
      //                 viewBox="0 0 24 24"
      //                 xml:space="preserve"
      //                 xmlns="http://www.w3.org/2000/svg"
      //                 xmlns:xlink="http://www.w3.org/1999/xlink"
      //               >
      //                 <path
      //                   fill="#e11616"
      //                   d="M16.4,4C14.6,4,13,4.9,12,6.3C11,4.9,9.4,4,7.6,4C4.5,4,2,6.5,2,9.6C2,14,12,22,12,22s10-8,10-12.4C22,6.5,19.5,4,16.4,4z"
      //                 />
      //               </svg>`;

      // corazon.appendChild(svg);

      let svg2 = document.createElement("span");
      svg2.innerHTML = `<svg
                      ref=""
                      width="100"
                      class="ml-2 mt-n2 animado"
                      enable-background="new 0 0 24 24"
                      id="Layer_1"
                      version="1.0"
                      viewBox="0 0 24 24"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <path
                        fill="#e11616"
                        d="M16.4,4C14.6,4,13,4.9,12,6.3C11,4.9,9.4,4,7.6,4C4.5,4,2,6.5,2,9.6C2,14,12,22,12,22s10-8,10-12.4C22,6.5,19.5,4,16.4,4z"
                      />
                    </svg>`;
      let corazon2 = this.$refs.corazon2;
      corazon2.appendChild(svg2);

      // let corazon1 = document.querySelector(".animado");
      // corazon1.classList.remove("animar");

      setTimeout(function () {
        let corazones = document.querySelectorAll(".animado");
        corazones.forEach((element) => {
          element.classList.add("animar");
        });
      }, 10);
    },
    initJuego() {
      this.comenzo = true;
      this.isRunning = true;
      this.startTime();
    },
    shuffle(array) {
      array.sort(() => Math.random() - 0.5);
      return array;
    },
    async startTime() {
      var thes = this;
      this.time_init = this.$store.getters.timeInit;
      //console.log("start time");
      //console.log({ timeinit: this.time_init });
      if (this.time_init == null || this.time_init == 0) {
        this.time_init = moment();
        this.$store.dispatch("setTimeInit").then(
          (response) => {
            thes.time_init = thes.$store.getters.timeInit;
            const ahora = moment();
            thes.time = ahora.diff(thes.time_init, "seconds");
            //console.log({segundos: thes.time})
          },
          (error) => {
            console.log(error);
          }
        );
      }
      this.startTimer();
    },
    startTimer() {
      if (this.isRunning === true) {
        //console.log({ timeinit: this.time_init });
        const ahora = moment();
        this.time = ahora.diff(this.time_init, "seconds");
        //console.log({ time: this.time });
        this.interval = setInterval(this.incrementTime, 1000);
      }
    },
    incrementTime() {
      if (this.isRunning === true) {
        this.time = parseInt(this.time) + 1;
        this.time_txt = parseInt(TIEMPO_PARTICIPACION) - parseInt(this.time);
        if (this.time_txt <= 0) {
          this.terminarJuego();
        }
      }
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    terminarJuego() {
      //console.log("terminar juego");
      this.termino = true;
      this.isRunning = false;

      //this.$store.state.loading =  true;
      this.$store.dispatch("showLoader", true);

      //registro bd
      const https = require("https");

      var qData = {
        email: this.userProfile.email,
      };

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getB.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data

            console.log("res getB");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              //
              //registro firebase

              let beneficios = {
                beneficio1:{
                  barcode: res.barcode1,
                  nombre: res.nombre1,
                  id_beneficio: res.id_beneficio1
                },
                beneficio2:{
                  barcode: res.barcode2,
                  nombre: res.nombre2,
                  id_beneficio: res.id_beneficio2
                },
                beneficio3:{
                  barcode: res.barcode3,
                  nombre: res.nombre3,
                  id_beneficio: res.id_beneficio3
                },
                beneficio4:{
                  barcode: res.barcode4,
                  nombre: res.nombre4,
                  id_beneficio: res.id_beneficio4
                },
              };

              qData = {
                time_txt: this.time_txt,
                time: this.time,
                puntos: this.evalua(),
                respuestas: this.disponibles_temp,
                beneficios: beneficios
              };
              this.$store.dispatch("registraTrivia", qData);


            } else {
              //

              //swal.fire("Oops", res.msg, "warning");
              
              qData = {
                time_txt: this.time_txt,
                time: this.time,
                puntos: this.evalua(),
                respuestas: this.disponibles_temp,
                beneficios: null
              };
              this.$store.dispatch("registraTrivia", qData);

            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );

     
    },
    evalua() {
      let puntos = 0;
      this.disponibles_temp.forEach((pregunta) => {
        if (pregunta.seleccionada == pregunta.rcorrecta) {
          puntos += 1000;
        }
      });
      return puntos;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
